import styles from "./profile-card.module.css";

type ProfileCardProps = {
  title: string;
  value?: string | number | null;
};

const ProfileCard = ({ title, value }: ProfileCardProps) => {
  return (
    <div className={styles.card}>
      <p className={styles.title}>{title}</p>
      <p className={styles.value}>{value}</p>
    </div>
  );
};

export default ProfileCard;
